module.exports = __webpack_public_path__ + "img/no-data.71a2eee9.jpg";